import useBasketData from '../../../hooks/useBasketData'
import { useI18n } from '../../../provider/i18n'

const Services = () => {
  const i18n = useI18n()
  const { orderCost, form } = useBasketData()
  const collectionType = form.watch('collectionType') || 'home'
  const isStationary = collectionType === 'stationary'

  if (isStationary) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {/* <span className="text-lg md:text-lg font-bold">
        {i18n.t('screens.basket.form.deliveryCollectionCost.label')}
      </span> */}
      {!!orderCost?.collections?.[0] && (
        <div className="flex flex-col gap-4 bg-white border-b border-b-border border-opacity-20 rounded-lg">
          <div>
            <div className="flex justify-between text-base text-blue-700 border-b border-b-border border-opacity-20 p-2 md:px-4">
              <span>
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.serviceLabel'
                )}
              </span>
              <span className="font-bold">
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.serviceValue',
                  {
                    serviceCost: (
                      Number(
                        orderCost.collections[0]
                          .collectionCostBeforeDiscount ||
                          orderCost.collections[0].collectionCost
                      ) +
                      Number(
                        orderCost.collections[0]
                          .collectionKitCostBeforeDiscount ||
                          orderCost.collections[0].collectionKitCost
                      )
                    ).toFixed(2),
                  }
                )}
              </span>
            </div>
            <div className="flex justify-between text-base text-blue-700 p-2 md:px-4">
              <span>
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.deliveryLabel',
                  { costPerKm: orderCost.collections[0].deliveryCostPerKm }
                )}
              </span>
              <span className="font-bold">
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.deliveryValue',
                  {
                    cost: Number(
                      orderCost.collections[0].deliveryCostBeforeDiscount ||
                        orderCost.collections[0].deliveryCost
                    ).toFixed(2),
                  }
                )}
              </span>
            </div>
            {/* <div className="flex justify-between text-base text-blue-700 p-2 md:px-4">
              <span>
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.collectionKitLabel'
                )}
              </span>
              <span className="font-bold">
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCost.collectionKitValue',
                  {
                    collectionKitCost: Number(
                      orderCost.collections[0]
                        .collectionKitCostBeforeDiscount ||
                        orderCost.collections[0].collectionKitCost
                    ).toFixed(2),
                  }
                )}
              </span>
            </div> */}
          </div>
          {/* <div>
            <p className="text-base font-bold text-blue-700 text-right whitespace-nowrap">
              {i18n.t('screens.basket.form.deliveryCollectionCost.total', {
                total: Number(
                  orderCost.collections[0].deliveryCost +
                    orderCost.collections[0].collectionCost +
                    orderCost.collections[0].collectionKitCost
                ).toFixed(2),
              })}
            </p>
            {(orderCost.collections[0].deliveryCostBeforeDiscount ||
              orderCost.collections[0].collectionCostBeforeDiscount ||
              orderCost.collections[0].collectionKitCostBeforeDiscount) && (
              <p className="font-bold text-right text-red-700 line-through">
                {i18n.t(
                  'screens.basket.form.deliveryCollectionCostBeforeDiscount.total',
                  {
                    total: Number(
                      (orderCost.collections[0].deliveryCostBeforeDiscount ||
                        orderCost.collections[0].deliveryCost) +
                        (orderCost.collections[0]
                          .collectionCostBeforeDiscount ||
                          orderCost.collections[0].collectionCost) +
                        (orderCost.collections[0]
                          .collectionKitCostBeforeDiscount ||
                          orderCost.collections[0].collectionKitCost)
                    ).toFixed(2),
                  }
                )}
              </p>
            )}
          </div> */}
        </div>
      )}
    </div>
  )
}

export default Services
